<template>
  <div>
    <b-tabs content-class="mt-1">
      <b-tab title="Production">
        <vue-autosuggest
          :suggestions="filteredOptions"
          :limit="25"
          :input-props="{id:'autosuggest__input',class:'form-control', placeholder:'Search by Email, First Name or Last Name'}"
          @input="onInputChange"
        >
          <template slot-scope="{suggestion}">
            <div
              style="z-index: 4444;cursor: pointer"
              @mouseup="onSelected(suggestion.item)"
            >
              {{ suggestion.item }}
            </div>
          </template>
        </vue-autosuggest>
        <br>
        <DataTable
          id="account.email"
          api="/admin/accounts/summary"
          id-url="/accounts/"
          :columns="columns"
        />
      </b-tab>

      <b-tab title="Black Listed">
        <DataTable
          api="/admin/black-listed-accounts"
        />
      </b-tab>

      <b-tab title="Delete Account Requests">
        <DataTable
          api="/admin/accounts/delete-requests"
        />
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
import DataTable from '@core/components/data-table/DataTable.vue'
import { VueAutosuggest } from 'vue-autosuggest'
import firebase from 'firebase'
import axios from 'axios'
import {
  BTabs, BTab,
} from 'bootstrap-vue'


export default {
  components: {
    DataTable,
    VueAutosuggest,
    BTabs,
    BTab,
  },
  data() {
    return {
      datasuggest: [],
      debounceMilliseconds: 250,
      timeout: null,
      filteredOptions: [],
      limit: 25,
      selected: null,
      columns: [
        { key: 'account.email', label: 'Email' },
        { key: 'account.firstName', label: 'First Name' },
        { key: 'account.lastName', label: 'Last Name' },
        { key: 'purchaseCount', label: 'Purchases' },
        { key: 'deviceCount', label: 'Devices' },
        { key: 'account.status', label: 'Status' },
        { key: 'account.created', label: 'Created' },
      ],
    }
  },
  methods: {
    onInputChange(text) {
      if (text === '' || text === undefined) {
        this.filteredOptions = []
        return
      }

      const search = {
        index: 'accounts',
        keyword: text,
      }

      // the reader's admin API (needs the admin login), not the old public "search" function
      const url = `${this.$readerURL}/admin/accounts/search`
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        firebase.auth().currentUser.getIdToken(false).then(idToken => {
          axios.post(url, search,
            {
              headers: {
                Authorization: idToken,
              },
            }).then(response => {
            const emails = []
            response.data.data.forEach(element => emails.push(element.email))
            this.filteredOptions = [{ data: emails }]
            return response
          }).catch(error => error)
        })
      }, this.debounceMilliseconds)
    },
    onSelected(event) {
      this.$router.push(`accounts/${event}`)
    },
  },
}
</script>

<style>
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  font-family: monospace;
  font-size: 20px;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  position: absolute;
  z-index: 10000001;
  color: black;
  font-weight: bold;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  overflow-y: scroll;
  max-height: 500px;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, .6);
}

.autosuggest__results ul {
  list-style: none;
  padding: 10px;
  margin: 0;
}

.autosuggest__results li {
  list-style: none;
  padding: 10px;
  margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  font-size: 12px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}
.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #ddd;
}

</style>
